import { Router, RouterLink } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Component, OnInit, OnDestroy, inject, ChangeDetectionStrategy } from '@angular/core';

import { Store } from '@ngxs/store';
import { OrganizationActions, OrganizationState, Organization, OrganizationListItem, Account, AccountState } from '@app/_store';
import { Observable, Subject } from 'rxjs';
import { Navigate } from '@ngxs/router-plugin';
import { hasActionsExecuting } from '@ngxs-labs/actions-executing';
import { friendlyDateTimeWithDayShort, PreviousRouteService } from '@app/_helpers';
import { NgIf, NgFor, NgClass, AsyncPipe, DatePipe } from '@angular/common';

@Component({
  templateUrl: 'home.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgIf, NgFor, NgClass, RouterLink, AsyncPipe, DatePipe],
})
export class HomeComponent implements OnInit, OnDestroy {
  componentDestroyed$: Subject<boolean> = new Subject<boolean>();

  account$: Observable<Account> = inject(Store).select(AccountState.account);

  isLoadingOrganizations$: Observable<boolean> = inject(Store).select(hasActionsExecuting([OrganizationActions.LoadAll]));

  organizations: OrganizationListItem[];

  friendlyDateTimeWithDayShort = friendlyDateTimeWithDayShort;

  constructor(
    private store: Store,
    private router: Router,
    private previousRouteService: PreviousRouteService
  ) {}

  ngOnInit(): void {
    this.store
      .select(OrganizationState.organizations)
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(data => {
        if (data?.length === 1 && this.previousRouteService.getPreviousUrl() == '/') {
          this.router.navigate(['organization', data[0].id]);
          return;
        }
        this.organizations = data;
      });
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }

  view(organization: Organization): void {
    if (organization.verified) {
      this.store.dispatch(new Navigate(['organization', organization.id]));
    }
  }
}
